import React, { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import Popup from 'reactjs-popup';
//import { LogoutModal } from '../components/LogoutModal';
import ServiceCalls from '../utils/serviceCalls.js';
import { Button } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

import '../styles/PopUps.css';
export default function IdleTimerContainer(props) {
    const { logout } = useAuth();
    const [isIdle, setIsIdle] = useState(false);

    const onPrompt=()=> {
        setIsIdle(true);
    }
    const onIdle = () => {
        if (isIdle) {
            ServiceCalls.idleLogout().then(function () {
                setIsIdle(false);
                logout();
            });           
        }
    }

    const onExtendTime = () => {
        ServiceCalls.extendLogin().then(function () {
           console.log('User extended Time');
           setIsIdle(false);
         });
    }
    // eslint-disable-next-line no-unused-vars
    const IdleTimer = useIdleTimer({
        onIdle,
        onPrompt,
        // timeout: 30 minutes: 30 [min] * 60 [sec] * 1000 [ms]  == 1800000
        timeout: (props.idleTimeout-1) * 60 * 1000,
        promptTimeout: 15000, //15 * 1000,
        element: document.getElementById('root'),
        events: [
            'mousemove',
            'keydown',
            'wheel',
            'DOMMouseScroll',
            'mousewheel',
            'mousedown',
            'touchstart',
            'touchmove',
            'MSPointerDown',
            'MSPointerMove',
            'visibilitychange'
        ]
    })

    return (
        (isIdle) ?
            <><Popup open={isIdle} modal closeOnDocumentClick={false}>
                {<>
                    <div className='confirm-modal'>
                        <h4 className="idleNoteArea">You've been inactive for 30 minutes. Press Logout to exit, or Extend to stay logged in. You will be automatically logged out in 10 seconds.</h4>
                    </div>
                    <div className="confirm-modal-buttons">
                        <Button className="idleNoteBtn" onClick={() => { logout() }}>Logout</Button>
                        <Button className="idleNoteBtn" onClick={() => { onExtendTime() }}>Extend</Button>
                    </div>
                </>}
            </Popup>
        </>
            :
            <></>
    );
} 